import React, { useEffect, useMemo } from 'react';

import { Stack } from '@mui/material';
import { GridColDef, GridRowsProp } from '@mui/x-data-grid-pro';
import { useQuery } from '@tanstack/react-query';

import { FormFilterOperacoes } from '..';

import { EditRemoveBtn } from 'components/buttons';
import { PanelGrid } from 'components/grid';
import { Block, OneColumn } from 'components/page';
import { useListagemContext } from 'context/ListagemContext';
import { RequestOptionsType, useRequestListagem } from 'hooks/useRequestListagem';

const generateOperacoesList = (data: any[] | undefined): GridRowsProp => {
    const list = data;

    if (Array.isArray(list) && list.length) {
        return list.map((item, index) => ({
            id: index + 1,
            idOperacao: item.idOperacao,
            dsOperacao: item.dsOperacao,
            cdOperacao: item.cdOperacao,
        }));
    }
    return [];
};

export function OperacoesListComp() {
    const { filter, page, sort, limit } = useListagemContext();
    const RequestListagem = useRequestListagem();

    const requestOptions: RequestOptionsType = {
        url: '/gestao/operacao',
        sort: sort && sort.length > 0 ? sort : [{ property: 'idOperacao', direction: 'DESC' }],
        columns: 'idOperacao,dsOperacao,cdOperacao,fgAtivo',
        nested: true,
        filter: [...filter, { property: 'fgAtivo', value: true, operator: 'eq' }],
        page,
        limit,
    };

    const { fetchStatus, data, refetch } = useQuery([requestOptions], () => {
        const request: Promise<any> = RequestListagem(requestOptions).then((res: any) => res.data);
        return request;
    });

    const columns: GridColDef[] = useMemo(
        () => [
            { field: 'idOperacao', headerName: 'Código', alignItems: 'center', flex: 1, type: 'string' },
            { field: 'dsOperacao', headerName: 'Descrição', alignItems: 'center', flex: 1, type: 'string' },
            { field: 'cdOperacao', headerName: 'Código de Integração', alignItems: 'center', flex: 1, type: 'string' },
            {
                field: 'acoes',
                align: 'center',
                headerAlign: 'center',
                headerName: 'Ações',
                filterable: false,
                sortable: false,
                hideable: false,
                disableColumnMenu: true,
                width: 110,
                renderCell: ({ row }) => (
                    <EditRemoveBtn
                        id={row.idOperacao}
                        showEditBtn={true}
                        showRemoveBtn={true}
                        removeUrl={`gestao/operacao/${row.idOperacao}`}
                        sx={{ ml: 'auto', p: 1.5 }}
                        refresh={refetch}
                    />
                ),
            },
        ],
        [refetch],
    );

    const rows = generateOperacoesList(data?.data);

    useEffect(() => {
        refetch();
    }, []);

    return (
        <OneColumn title="Operações" createButton>
            <FormFilterOperacoes />

            <Block>
                <PanelGrid rows={rows} rowsCount={data?.total ?? 0} reload={refetch} loading={fetchStatus === 'fetching'} columns={columns} />
            </Block>
        </OneColumn>
    );
}
